import React from 'react'
import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import MomentUtils from '@date-io/moment'
import { Provider as StoreProvider } from 'react-redux'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { renderRoutes } from 'react-router-config'
import { SnackBar } from 'components/SnackBar'
import { AuthProvider } from 'providers/authProvider'
import { FilterProvider } from 'providers/filterProvider'
import { CestaProvider } from 'providers/CestaProvider'
import { ThemeModeProvider } from 'providers/ThemeModeProvider'
import { configureStore } from './store'
import routes from './routes'
import { ScrollReset } from './components'

import './mixins/chartjs'
import './mixins/moment'
import './mixins/validate'
import './mixins/prismjs'
import './assets/scss/index.scss'

const history = createBrowserHistory({
  forceRefresh: false,
})

const store = configureStore()

export const App = () => (
  <StoreProvider store={store}>
    <ThemeModeProvider>
      <Router history={history}>
        <AuthProvider>
          <CestaProvider>
            <FilterProvider>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <SnackBar />
                <ScrollReset />
                {renderRoutes(routes)}
              </MuiPickersUtilsProvider>
            </FilterProvider>
          </CestaProvider>
        </AuthProvider>
      </Router>
    </ThemeModeProvider>
  </StoreProvider>
)

